import type { AudioInputModuleEvents, AudioInputState } from "./AudioInput.types.ts";

type EventName = keyof AudioInputModuleEvents;
type EventListener<E extends EventName> = AudioInputModuleEvents[E];

interface AudioInputWebStub {
  addListener<E extends EventName>(event: E, listener: EventListener<E>): { remove(): void };
  getInputs(): Promise<AudioInputState>;
  setPreferredInput(uid: string | null): Promise<void>;
}

const EMPTY_STATE: AudioInputState = { activeInputUid: null, inputs: [] };

// Web has no AVAudioSession input routing — the editor's mic picker simply
// doesn't render. Mirror the native surface as no-ops so consumers don't branch.
const stub: AudioInputWebStub = {
  addListener() {
    return { remove() {} };
  },
  getInputs() {
    return Promise.resolve(EMPTY_STATE);
  },
  setPreferredInput() {
    return Promise.resolve();
  },
};

export const NativeModule = stub;
